import { AbstractProgress } from 'foundations-components/transitional/components/AbstractProgress';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import { useRefreshProgress } from './machine/useRefreshProgress';

/**
 * GridListRefreshProgress
 *
 * @description A grid list component that exposes a small, animating progress bar
 * when the GridList is passed isRefreshing=true.
 *
 * Implements a 150ms loading delay before showing the progress bar to prevent
 * unnecessary progress bars for near-instantaneous refreshes. When isRefreshing
 * transitions from true to false, it animates the progress bar to 100% before
 * hiding it after 100ms.
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function GridListRefreshProgress() {
  const {
    isVisible,
    progressValue,
    updateProgress
  } = useRefreshProgress();
  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/_jsx(AbstractProgress, {
    completionLingerTime: 1,
    incrementFactor: 0.1,
    maximum: 100,
    render: ({
      value
    }) => {
      updateProgress(value);
      return /*#__PURE__*/_jsx(NanoProgress, {
        value: progressValue
      });
    }
  });
}